module.exports = __webpack_public_path__ + "img/step2-fr.ca4fd8a8.webp";